'use client'

import { useReviewsDataQuery } from '@/hooks/useContentfulQuery'
import { ReviewsWrapper, ReviewsTrack } from '@/components/styled/ReviewsLoop'
import ReviewItem from './ReviewItem'
import { useTranslation } from 'react-i18next'
import { GA_EVENTS } from '@/utils/analytics'
import { useEffect } from 'react'

const ReviewsSection = () => {
  const { t } = useTranslation('home')

  const contentType = 'review'

  const { data: reviews, isPending } = useReviewsDataQuery(contentType)

  useEffect(() => {
    if (reviews?.length) {
      GA_EVENTS.SECTION_VIEW('reviews_section')
    }
  }, [reviews])

  if (isPending) return <p>Loading...</p>

  if (!reviews?.length) return <p>후기가 없습니다.</p>

  const reviewsToShow = [...reviews, ...reviews]

  return (
    <section className="w-full flex flex-col justify-center text-center mx-auto mt-[150px] sm:mt-[334px] mb-[150px] sm:mb-[247px] sm:gap-4">
      <h2 className="text-[24px] sm:text-[40px] text-main-light-1 dark:text-main-dark-1 tracking-[-0.05em]">
        {t('review_text_1')}
      </h2>
      <p className="text-[15px] leading-[22px] sm:text-[24px] text-main-light-3 dark:text-main-dark-3">
        {t('review_text_2')}
      </p>

      <ReviewsWrapper>
        <ReviewsTrack>
          {reviewsToShow.map((review, index) => (
            <div
              className="flex flex-col items-start w-[230px] sm:w-[288px] h-auto p-[20px] sm:p-[27px] bg-theme-light-gray-50 dark:bg-theme-dark-gray-500 rounded-[28px] break-words whitespace-normal"
              key={index}
            >
              <ReviewItem
                rating={review.rating}
                title={review.title}
                author={review.author}
                authoredAt={review.authoredAt}
                description={review.description}
              />
            </div>
          ))}
        </ReviewsTrack>
      </ReviewsWrapper>
    </section>
  )
}

export default ReviewsSection
